"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferingLocationDtoBuilder = void 0;
var offering_location_dto_1 = require("./offering-location.dto");
var OfferingLocationDtoBuilder = /** @class */ (function () {
    function OfferingLocationDtoBuilder() {
        this.location = {
            type: offering_location_dto_1.ServiceLocationType.OWNER_BUSINESS,
            locationText: 'location text',
        };
    }
    OfferingLocationDtoBuilder.prototype.withType = function (type) {
        this.location.type = type;
        return this;
    };
    OfferingLocationDtoBuilder.prototype.withLocationText = function (locationText) {
        this.location.locationText = locationText;
        return this;
    };
    OfferingLocationDtoBuilder.prototype.build = function () {
        return this.location;
    };
    return OfferingLocationDtoBuilder;
}());
exports.OfferingLocationDtoBuilder = OfferingLocationDtoBuilder;
//# sourceMappingURL=offering-location.dto.builder.js.map